// extracted by mini-css-extract-plugin
module.exports = {"root":"Option_root__1f4RT","row":"Option_row__2g-xd"};